import OrderRequests from '@/shared/infrastructure/orders/Request'

const actions = {
  fetchOrderInfo(action, id) {
    return OrderRequests.fetchOrderInfo(id)
  },
  fetchOrderInvoice(action, id) {
    return OrderRequests.fetchOrderInvoice(id)
  },
  cancelOrder(action, payload) {
    return OrderRequests.cancelOrder(payload)
  },
  openServiceRequest(action, payload) {
    return OrderRequests.openServiceRequest(payload)
  },
  fetchSourcingOrderInfo(action,payload) {
    return OrderRequests.fetchSourcingOrderInfoRequest(payload)
  }
}

export default actions
